export default __webpack_public_path__ + "images/73d983f57c181ca8ab352d4fc0743079.svg";